"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = ChevronRightSmall;

var _ChevronRightSmall = require("@adobe/react-spectrum-ui/dist/ChevronRightSmall");

var _icon = require("@react-spectrum/icon");

var _react = _interopRequireDefault(require("react"));

function ChevronRightSmall(props) {
  return /*#__PURE__*/_react.default.createElement(_icon.UIIcon, props, /*#__PURE__*/_react.default.createElement(_ChevronRightSmall.ChevronRightSmall, null));
}